/**
 * Cassanova API Configuration
 *
 * This module exports configuration constants for the Cassanova API client.
 * Values are loaded from environment variables with secure fallbacks.
 *
 * @module cassanova/config
 */

/**
 * Cassanova API base URL
 * @type {string}
 */
export const API_URL = process.env.REACT_APP_CASSANOVA_API_URL || 'https://api.cassanova.com';

/**
 * Cassanova API key for authentication
 * @type {string}
 */
export const API_KEY = process.env.REACT_APP_CASSANOVA_API_KEY || 'd4aa5eda-25af-40b7-a25c-09820b2ab1fd';

/**
 * Sales point ID for menu data
 * @type {string}
 */
export const SALES_POINT_ID = process.env.REACT_APP_CASSANOVA_SALES_POINT_ID || '20002';

/**
 * SessionStorage key for token caching
 * @type {string}
 */
export const TOKEN_STORAGE_KEY = 'cassanova_token';

/**
 * API version header value
 * @type {string}
 */
export const API_VERSION = '1.0.0';

/**
 * Request timeout in milliseconds
 * @type {number}
 */
export const REQUEST_TIMEOUT = 10000; // 10 seconds

/**
 * Token refresh buffer in milliseconds (5 minutes)
 * Tokens will be refreshed this amount of time before expiry
 * @type {number}
 */
export const TOKEN_REFRESH_BUFFER = 5 * 60 * 1000; // 5 minutes

/**
 * Maximum number of retry attempts for failed requests
 * @type {number}
 */
export const MAX_RETRY_ATTEMPTS = 1;

/**
 * Complete configuration object
 * @type {Object}
 */
export const CASSANOVA_CONFIG = {
    apiUrl: API_URL,
    apiKey: API_KEY,
    salesPointId: SALES_POINT_ID,
    tokenStorageKey: TOKEN_STORAGE_KEY,
    apiVersion: API_VERSION,
    requestTimeout: REQUEST_TIMEOUT,
    tokenRefreshBuffer: TOKEN_REFRESH_BUFFER,
    maxRetryAttempts: MAX_RETRY_ATTEMPTS,
};

/**
 * Validate configuration on module load
 * Logs warnings if critical values are missing
 */
if (process.env.NODE_ENV !== 'production') {
    if (!API_KEY || API_KEY === 'd4aa5eda-25af-40b7-a25c-09820b2ab1fd') {
        console.warn('[Cassanova Config] Using default API key. Set REACT_APP_CASSANOVA_API_KEY in .env for production.');
    }
    if (!API_URL) {
        console.warn('[Cassanova Config] API URL not configured. Using default:', API_URL);
    }
    if (!SALES_POINT_ID) {
        console.warn('[Cassanova Config] Sales Point ID not configured. Using default:', SALES_POINT_ID);
    }
}

export default CASSANOVA_CONFIG;
